import { getCurrentConsent } from '@tv2/ui-cmp/Cookiebot';

export const waitForTargetRendering = () =>
  new Promise((res, rej) => {
    document.addEventListener('at-content-rendering-succeeded', () => res());
    setTimeout(() => rej(new Error('Target did not render')), 400);
  });

/**
 This promise resolves when target is ready
 It throws if target has not fully loaded within 1000ms
 */
let targetLoadedPromise;
export const targetLoaded = () => {
  if (!targetLoadedPromise) {
    targetLoadedPromise = new Promise((res, rej) => {
      if (window.adobe?.target) res();
      else {
        document.addEventListener('at-library-loaded', () => res());
        setTimeout(() => rej(new Error('Target timed out')), 1000);
      }
    });
  }
  return targetLoadedPromise;
};

/**
 * makes ajax request to get all adobe target experiments.
 */
let getOffersPromise;
function getOffers() {
  if (!getOffersPromise)
    getOffersPromise = window.adobe.target
      .getOffers({
        request: {
          execute: {
            pageLoad: {
              params: {},
            },
          },
          prefetch: {
            views: [{}],
          },
        },
      })
      .then(response => window.adobe.target.applyOffers({ response }))
      .catch(() => {});
  return getOffersPromise;
}

/**
 This promise resolves when consents have been loaded or granted by the user
 It throws an error if we cannot load target or we do not get consents.
 */
export async function targetConsented() {
  const currentConsent = await getCurrentConsent();
  if (currentConsent) {
    await targetLoaded();
    window.adobe.optIn.approve(['ecid', 'target']);
    await getOffers();
  } else {
    throw new Error('no consent');
  }
}

/**
 This promise resolves when previous consents have been loaded
 It throws an error when the cookiebot dialog opens, or after 1000ms
 */
let targetConsentedOrPromptedPromise;
export function targetConsentedOrPrompted() {
  if (targetConsentedOrPromptedPromise) return targetConsentedOrPromptedPromise;

  targetConsentedOrPromptedPromise = new Promise((res, rej) => {
    targetConsented().then(res).catch(rej);
    window.addEventListener('CookiebotOnDialogInit', rej, false);
    setTimeout(() => rej(), 1000);
  });

  return targetConsentedOrPromptedPromise;
}
